import "UI/Widget/Forms/Control/Label";
NS("UI.Widget.Forms.Control");

UI.Widget.Forms.Control.Counter = Class(UI.Widget.Forms.Control.Label, {
    updateElement: function(value) {
        this.$element.text(Util.isDefined(value) ? value.value : null);
    },
});
